import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Crown } from "lucide-react";

/**
 * Compact royal-blue page header used on every non-home page
 * (since the main app header is hidden off the home screen).
 * Shows a back button, page title and (optionally) a right-side slot.
 */
export default function PageHeader({ title, right, backTo, testId }) {
  const navigate = useNavigate();
  const onBack = () => (backTo ? navigate(backTo) : navigate(-1));
  return (
    <div
      className="sticky top-0 z-30 bg-gradient-to-r from-blue-950 via-blue-900 to-indigo-950 text-white px-3 py-2.5 flex items-center gap-2 shadow-lg border-b-2 border-yellow-400/60 -mx-3 -mt-3 mb-3"
      data-testid={testId || "page-header"}
    >
      <button
        onClick={onBack}
        className="p-1.5 -ml-1 rounded-full hover:bg-white/10 active:scale-90"
        aria-label="Back"
        data-testid="page-header-back"
      >
        <ChevronLeft className="w-5 h-5" />
      </button>
      <Link to="/" className="p-1 -ml-1 rounded-full hover:bg-white/10 active:scale-90" aria-label="Home" data-testid="page-header-home">
        <Crown className="w-4 h-4 text-yellow-400" fill="currentColor" />
      </Link>
      <h1 className="font-display font-black text-base tracking-wide text-gold-static flex-1 truncate">
        {title}
      </h1>
      {right}
    </div>
  );
}
